module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-收起内容.06e7c.png";